/**
 * ヘッダーに関するクラス
 */

export default class SmoothScroll {
  constructor(_parm) {
    this.elmHeader = document.querySelector('#js-header');
    this.elmScrollTriger = document.querySelector('#js-header-scroll-triger');
  }

  /**
   * スクロールしたら、ヘッダーのスタイルを変える
   */
  headerIntersectionObserver() {
    // オプション
    const options = {
      root: null,
      rootMargin: '-50% 0px',
      threshold: 0,
    };
    // 監視開始
    const observerHeader = new IntersectionObserver((entries) => {
      entries.forEach(_entry => {
        if (_entry.isIntersecting) {
          this.elmHeader.setAttribute('data-js-scroll', 'false');
        } else {
          this.elmHeader.setAttribute('data-js-scroll', 'true');
        }
      });
    });
    observerHeader.observe(this.elmScrollTriger, options);

  }

  init() {
    this.headerIntersectionObserver();
  }
}
